var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.616,
    height: 17.616,
    viewBox: "0 0 17.616 17.616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-search",
    "data-name": "Icon feather-search",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11967",
    "data-name": "Path 11967",
    d: "M10.927,3A7.927,7.927,0,1,1,5.322,5.322,7.876,7.876,0,0,1,10.927,3Zm0,14.093a6.166,6.166,0,1,0-6.166-6.166A6.173,6.173,0,0,0,10.927,17.093Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11968",
    "data-name": "Path 11968",
    d: "M28.187,29.068a.878.878,0,0,1-.623-.258l-3.832-3.832a.881.881,0,0,1,1.246-1.246l3.832,3.832a.881.881,0,0,1-.623,1.5Z",
    transform: "translate(-8.452 -8.452)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.48533a85dba651dbd578eca85029ef3c.svg";
export { ForwardRef as ReactComponent };